import { render, staticRenderFns } from "./point.vue?vue&type=template&id=7a3ef28e&scoped=true&"
import script from "./point.vue?vue&type=script&lang=ts&"
export * from "./point.vue?vue&type=script&lang=ts&"
import style0 from "./point.vue?vue&type=style&index=0&id=7a3ef28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3ef28e",
  null
  
)

export default component.exports